import styles from "./Body.module.scss";

import backgroundImage from "../../../assets/3894385.jpg";

import LoginButton from "./LoginButton";

import { motion } from "framer-motion";

let easeing = [0.6, -0.05, 0.01, 0.99];

const stagger = {
  animate: {
    transition: {
      delayChildren: 0.4,
      staggerChildren: 0.2,
      staggerDirecion: 1,
    },
  },
};

const fadeInUp = {
  initial: {
    y: -60,
    opacity: 0,
    transition: {
      duration: 0.6,
      ease: easeing,
    },
  },

  animate: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
      delay: 0.5,
      ease: easeing,
    },
  },
};

const transition = { duration: 1.4, ease: [0.6, 0.01, -0.05, 0.9] };

const firstName = {
  initial: {
    y: -20,
  },
  animate: {
    y: 0,
    transition: {
      delayChildren: 0.4,
      staggerChildren: 0.04,
      staggerDirecion: -1,
    },
  },
};

const lastName = {
  initial: {
    y: -20,
  },
  animate: {
    y: 0,
    transition: {
      delayChildren: 0.4,
      staggerChildren: 0.04,
      staggerDirecion: 1,
    },
  },
};

const letter = {
  initial: {
    y: 400,
  },
  animate: {
    y: 0,
    transition: { duration: 1, ...transition },
  },
};

const Body = () => {
  return (
    <>
      <motion.div
        className={styles.content_wrapper}
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3, ease: easeing }}
      >
        <div className={styles.left_content_wrapper}>
          <motion.h2>
            <motion.span
              variants={firstName}
              initial="initial"
              animate="animate"
              className={styles.first}
            >
              <motion.span variants={letter}>S</motion.span>
              <motion.span variants={letter}>c</motion.span>
              <motion.span variants={letter}>h</motion.span>
              <motion.span variants={letter}>e</motion.span>
              <motion.span variants={letter}>d</motion.span>
              <motion.span variants={letter}>u</motion.span>
              <motion.span variants={letter}>l</motion.span>
              <motion.span variants={letter}>e</motion.span>
              <motion.span variants={letter} className={styles.second}>
                A
              </motion.span>
              <motion.span variants={letter}>p</motion.span>
              <motion.span variants={letter}>p</motion.span>
            </motion.span>

            <motion.span
              variants={lastName}
              initial="initial"
              animate="animate"
              className={styles.last}
            >
              <motion.span variants={letter}>F</motion.span>
              <motion.span variants={letter}>o</motion.span>
              <motion.span variants={letter}>r</motion.span>
              <motion.span variants={letter} className={styles.second}>
                I
              </motion.span>
              <motion.span variants={letter}>n</motion.span>
              <motion.span variants={letter}>d</motion.span>
              <motion.span variants={letter}>i</motion.span>
              <motion.span variants={letter}>v</motion.span>
              <motion.span variants={letter}>i</motion.span>
              <motion.span variants={letter}>d</motion.span>
              <motion.span variants={letter}>u</motion.span>
              <motion.span variants={letter}>a</motion.span>
              <motion.span variants={letter}>l</motion.span>
              <motion.span variants={letter} className={styles.second}>
                &
              </motion.span>

              <motion.span variants={letter} className={styles.second}>
                T
              </motion.span>
              <motion.span variants={letter}>e</motion.span>
              <motion.span variants={letter}>a</motion.span>
              <motion.span variants={letter}>m</motion.span>
              <motion.span variants={letter}>s</motion.span>
            </motion.span>
          </motion.h2>
          <motion.p variants={fadeInUp}>
            Helping Teams And Individuals Organise their tasks in an automated
            way.
          </motion.p>
          <motion.div className={styles.btn_group} variants={stagger}>
            <LoginButton
              buttonText="Login"
              buttonStyle={`${styles.btn} ${styles.btn_primary}`}
              showIcon
            />
            <LoginButton
              buttonText="Get Started"
              buttonStyle={`${styles.btn} ${styles.btn_secondary}`}
              showIcon={false}
            />
          </motion.div>
        </div>
        <motion.div className={styles.right_content_wrapper}>
          <motion.img
            src={backgroundImage}
            alt="Background Image"
            initial={{ x: 200, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.8 }}
          />
        </motion.div>
      </motion.div>
    </>
  );
};

export default Body;
